import React from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CpoModel } from 'client/data/models/cpo';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';

export function CarsForSaleUI({ content, isMobile }) {
  return (
    <Container className="cars-for-sale mb-3" data-tracking-parent="edm-entry-internal-links">
      <div className="heading-3 mt-2 mb-1_5">Certified Pre-Owned Makes</div>
      <Row tag="ul" className="list-unstyled">
        {content.makeList?.map(({ href, anchorTextComponents }) => (
          <Col key={href} lg={4} tag="li" className="mb-1">
            <a href={href} className="text-blue-30">
              Certified Pre-Owned {anchorTextComponents.makeName}
            </a>
          </Col>
        ))}
      </Row>
      {isMobile && (
        <NativeAd
          adNameWired="mrect"
          adNameMobile="mmrect"
          nativeStyle="mediumrectangle"
          position={'1'}
          renderWhenViewable={false}
          refreshable={false}
          all
          showLabel
          useMinHeight
          wrapperClass="mb-3"
        />
      )}
      <div className="heading-3 mt-2 mb-1_5">Popular Certified Pre-Owned Models</div>
      <Row tag="ul" className="list-unstyled">
        {content.modelList?.map(({ href, anchorTextComponents }) => (
          <Col key={href} lg={4} tag="li" className="mb-1">
            <a href={href} className="text-blue-30">
              Certified Pre-Owned {anchorTextComponents.makeName} {anchorTextComponents.modelName}
            </a>
          </Col>
        ))}
      </Row>
      {isMobile && (
        <NativeAd
          adNameWired="mrect"
          adNameMobile="mmrect"
          nativeStyle="mediumrectangle"
          position={'2'}
          renderWhenViewable={false}
          refreshable={false}
          all
          showLabel
          useMinHeight
        />
      )}
    </Container>
  );
}

CarsForSaleUI.propTypes = {
  content: PropTypes.shape({
    makeList: PropTypes.arrayOf(
      PropTypes.shape({
        anchorTextComponents: PropTypes.shape({
          makeName: PropTypes.string,
        }),
        href: PropTypes.string,
      })
    ),
    modelList: PropTypes.arrayOf(
      PropTypes.shape({
        anchorTextComponents: PropTypes.shape({
          makeName: PropTypes.string,
          modelsName: PropTypes.string,
        }),
        href: PropTypes.string,
      })
    ),
  }),
  isMobile: PropTypes.bool,
};

CarsForSaleUI.defaultProps = {
  content: {},
  isMobile: false,
};

export const stateToPropsConfig = {
  content: bindToPath('carsForSale', CpoModel),
};

export const CarsForSale = connectToModel(CarsForSaleUI, stateToPropsConfig);
